<template>
  <v-container fluid grid-list-xl>
    <v-row>
      <v-col cols="3">
        <v-menu
          ref="menu"
          v-model="menu"
          :close-on-content-click="false"
          :return-value.sync="dates"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="formatedDates"
              class="calendar"
              solo
              readonly
              v-bind="attrs"
              v-on="on"
            >
            <template v-slot:append>
              <v-icon
              color="primary"
              v-bind="attrs"
              v-on="on"
              >arrow_drop_down_circle</v-icon>
            </template>
            </v-text-field>
          </template>
          <v-date-picker v-model="dates" no-title range scrollable>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="menu = false">
              Cancel
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="
                $refs.menu.save(dates);
                filterByDates();
              "
            >
              OK
            </v-btn>
          </v-date-picker>
        </v-menu>
      </v-col>
    </v-row>
    <v-layout row wrap>
      <!-- Widgets-->
      <v-flex d-flex lg3 sm6 xs12>
        <widget
          icon="shopping_cart"
          title="Orders"
          :subTitle="report.orderCount.toString()"
          color="primary"
          variant="#30ADAD"
        />
      </v-flex>
      <v-flex d-flex lg3 sm6 xs12>
        <widget
          icon="credit_card"
          title="REVENUE"
          :subTitle="'£'+report.revenue"
          color="orange"
          variant="#F08282"
        />
      </v-flex>
      <v-flex d-flex lg3 sm6 xs12>
        <widget
          icon="picture_in_picture"
          title="AVG ORDER"
          :subTitle="'£' + report.averageOrderValue"
          color="purple"
          variant="#7891FF"
        />
      </v-flex>
      <v-flex d-flex lg3 sm6 xs12>
        <widget
          icon="shopping_basket"
          title="AVG BASKET"
          :subTitle="report.averageBasketSize.toString()"
          color="dark-blue"
          variant="#29417B"
        />
      </v-flex>
      <!-- Widgets Ends -->
      <!-- Statistics -->
      <v-flex d-flex lg6 sm12 md6 xs12>
        <site-view-statistic label="Revenue" :key="key" class="w-100" :labels="revenueLabels" :chart-data="revenue" :period.sync="payload.period" @change="getSalesReport"/>
      </v-flex>
      <v-flex d-flex lg6 sm12 md6 xs12>
        <site-view-statistic label="Orders" class="w-100" :filters="false" :labels="orderCountLabels" :chart-data="orderCount" @change="getSalesReport"/>
      </v-flex>
      <!-- <v-flex d-flex lg6 sm6 xs12>
        <location-statistic class="w-100" />
      </v-flex> -->
    </v-layout>
  </v-container>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
export default {
  data() {
    return {
      menu: false,
      dates: [
        moment().startOf('month').format('YYYY-MM-DD'),
        moment().format('YYYY-MM-DD')
      ],
      payload: {
        fromDate: moment().startOf('month').format('YYYY-MM-DD'),
        toDate: moment().format('YYYY-MM-DD'),
        period: 'day'
      },
      key: 0
    };
  },
  computed: {
    report() {
      return this.$store.state.dashboard.report
    },
    formatedDates() {
        return moment(this.dates[0]).format('DD MMM YYYY') + ' - ' + moment(this.dates[1]).format('DD MMM YYYY')
    },
    revenueLabels() {
      return this.report.revenueByPeriod.map(a => {
        return a.month? a.month : (a.week ? a.week: (a.day ? a.day : a.year))
      })
    },
    orderCountLabels() {
      return this.report.ordersByPeriod.map(a => {
        return a.month? a.month : (a.week ? a.week: (a.day ? a.day : a.year))
      })
    },
    orderCount() {
      return this.report.ordersByPeriod.map(a => {
        return a.order_count
      })
    },
    revenue() {
      return this.report.revenueByPeriod.map(a => {
        return a.revenue
      })
    }
  },
  watch: {
    dates(val) {
      if(val[1] < val[0]) {
        let temp = val[0];
        val[0] = val[1]
        val[1] = temp
      }
    }
  },
  async mounted() {
    await this.getSalesReport();
  },
  methods: {
    async getSalesReport() {
      await this.$store.dispatch('dashboard/LOAD_DASHBOARD_DATA', {
        date_from: this.payload.fromDate,
        date_to: this.payload.toDate,
        period: this.payload.period
      });
      this.key++;
    },
    filterByDates() {
      this.payload.fromDate = this.dates[0];
      this.payload.toDate = this.dates[1];
      this.getSalesReport();
    }
  }
};
</script>

<style>
.w-100 {
  width: 100%;
}
.calendar .v-icon {
  color: #23a0a0 !important;
  caret-color: #23a0a0 !important;
}
</style>
